import { format, parseISO } from "date-fns";

export default function getFormattedDate(
  date: string | number,
  formatPattern = "dd.MM.yyyy",
) {
  if (typeof date === "string") {
    const dateObj = parseISO(date);
    return format(dateObj, formatPattern);
  }

  return format(date, formatPattern);
}
